module.exports = __webpack_public_path__ + "static/media/leaf.942ba555.png";